import styled from 'styled-components';
import { ReactComponent as IconTriangleSVG } from 'assets/icons/triangle.svg';
import { PlayerElements as Player, Heading } from 'components/elements';

export const Tooltip = styled.div`
	position: absolute;
	bottom: 7rem;
	right: 0rem;
	border: 1px solid rgb(255, 255, 255, 0.1);
	border-radius: 6px;
	opacity: 0;
	visibility: hidden;
	transition: all 0.3s ease-in-out;
`;

export const Bg = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background-color: black;
	opacity: 0.8;
	border-radius: 6px;
	z-index: -1;
`;

export const Container = styled(Player.Wrapper)`
	&:hover ${Tooltip} {
		opacity: 1;
		visibility: visible;
	}
`;

export const TooltipContent = styled.div`
	height: 100%;
	width: 100%;
	border-radius: 6px;
	display: flex;
	padding: 2rem 0;
`;

export const IconSettings = styled(Player.IconSettings)`
	cursor: pointer;
`;

export const IconTriangle = styled(IconTriangleSVG)`
	position: absolute;
	bottom: -1.3rem;
	right: 1.1rem;
`;

export const ProfileStyled = styled(Player.Profile)`
	margin-left: -1.7rem;
	text-transform: capitalize;
`;

export const SettingWrapper = styled.div`
	padding: 0 3rem;
	border-right: 1px solid rgb(255, 255, 255, 0.1);

	&:last-child {
		border-right: none;
	}
`;

export const SettingName = styled(Heading.Third)`
	margin-left: 0;
	text-align: center;
`;
